import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { listSkills, Skill, SkillFilters } from "../orders/orderAPI";

const skillAdapter = createEntityAdapter<Skill>();

export const fetchSkills = createAsyncThunk<
  Array<Skill>,
  SkillFilters,
  { state: RootState }
>(
  "projections/skills",
  async (filters: SkillFilters, { requestId }) =>
    await listSkills(filters, { requestId }),
);

type Entities = {
  [key: string]: any;
};

export type SliceState = {
  ids: [];
  entities: Entities;
  status: "idle" | "pending" | "succeeded" | "failed";
  error?: string;
};

export const skillsSlice = createSlice({
  name: "skills",
  initialState: skillAdapter.getInitialState({
    status: "idle",
  }) as SliceState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchSkills.pending, (state, action) => {
      if (action.meta.arg.term || action.meta.arg.workTitleIds) return;
      state.status = "pending";
    });
    builder.addCase(fetchSkills.fulfilled, (state, action) => {
      // Keep the full list for autocompletes; filtered fetches use the payload locally.
      if (action.meta.arg.term || action.meta.arg.workTitleIds) return;
      skillAdapter.setAll(state, action.payload);
      state.status = "succeeded";
    });
    builder.addCase(fetchSkills.rejected, (state, action) => {
      if (action.meta.arg.term || action.meta.arg.workTitleIds) return;
      state.error = action.error.message;
      state.status = "failed";
    });
  },
});

export const { selectAll: selectAllSkills } = skillAdapter.getSelectors(
  (state: RootState) => state.skills,
);

export default skillsSlice.reducer;
